import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { device } from "../device";
import { FullWidthImage } from "./";

const ImageContainer = styled.div`
margin-bottom: ${({last}) => 
    (last === 'xs' && '0') || 
    '24px'
};
@media ${device.sm} {
    margin-bottom: ${({last}) => 
        (last === 'xs' && '0') || 
        (last === 'sm' && '0') || 
        '32px'
    };
}
`;

function PlainImage(props) {
    return (
        <ImageContainer last={props.last}>
            <FullWidthImage src={props.src} alt="" />
        </ImageContainer>
    )
}

PlainImage.propTypes = {
    src: PropTypes.string
};

export default PlainImage;
